export const uniqueArray = <T extends Array<unknown>>(input: T): T =>
	Array.from(new Set(input).values()) as T;
